<template>
  <teleport to="#app">
    <oxd-dialog v-if="show" style="max-width:1150px" @update:show="onCancel">
      <InformationEdit
        :departments="departments"
        :is-modal="true"
        @onCancel="onCancel"
        @afterSubmit="afterSubmit"
      />
    </oxd-dialog>
  </teleport>
</template>

<script>
import Dialog from '@ohrm/oxd/core/components/Dialog/Dialog';
import InformationEdit from '../../../orangehrmTrainigPlugin/pages/InformationEdit.vue';
export default {
  components: {
    'oxd-dialog': Dialog,
    InformationEdit: InformationEdit,
  },
  props: {
    departments: {type: Array, default: () => []},
  },
  data() {
    return {
      show: false,
      reject: null,
      resolve: null,
    };
  },
  methods: {
    showDialog() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.show = true;
      });
    },
    afterSubmit(informationData) {
      this.show = false;
      this.resolve && this.resolve(informationData);
    },
    onCancel() {
      this.show = false;
      this.resolve && this.reject('cancel');
    },
  },
};
</script>

<style src="./dialog.scss" lang="scss" scoped></style>
